/*
    Dynamic Yield front-end helpers
*/

/**
 * Check if the new context is equivalent to the actual DY context
 * @param {Object} context new context
 * @param {Object} dyContext actual DY context
 * @returns {boolean} are contexts equivalents
 */
function isEquivalent(context, dyContext) {
    if (!dyContext) {
        return false;
    }
    var attributes = Object.keys(context);
    var dyContextAttributes = Object.keys(dyContext);
    var equivalent = attributes.length === dyContextAttributes.length;
    for (var attr of attributes) {
        if (typeof context[attr] === 'object') {
            equivalent = equivalent && isEquivalent(context[attr], dyContext[attr]);
        } else {
            equivalent = equivalent && context[attr] === dyContext[attr];
        }
        if (!equivalent) {
            break;
        }
    }
    return equivalent;
}

/**
 * Set DY context if the new context is different than the actual
 * @param {Object} newContext new context
 */
function setDYContext(newContext) {
    if (isEquivalent(newContext, window.DY.recommendationContext)) {
        return;
    }
    window.DY = window.DY || {};
    window.DY.recommendationContext = newContext;
}

/**
 * Set a DY recommendation context by modifying window.DY.recommendationContext.type && window.DY.recommendationContext.data
 * @param {Object} dataToBeSet data to be set otherwise data will be queried in input[name="dyData"]
 * @param {boolean} exactContext is dataToBeSet the only value to send or do we use the current recommendationContext as a base
 * @return {Object} previous recommendation context
 */
function setDyRecommendationContext(dataToBeSet, exactContext) {
    var dyData = document.querySelector('[name="dyData"]');

    if (!window.DY) { // Means DY not enabled
        return {};
    }

    var previousRecommendationContext = Object.assign({}, window.DY.recommendationContext);
    var newContext = exactContext ? {} : Object.assign({}, window.DY.recommendationContext);

    if (dataToBeSet) {
        Object.keys(dataToBeSet).forEach(function (key) {
            newContext[key] = dataToBeSet[key] || [];
        });
    } else if (dyData) {
        var dyDataParsed = JSON.parse(dyData.value);

        if (typeof dyDataParsed !== 'undefined') { // if JSON parsing ok
            Object.keys(dyDataParsed).forEach(function (key) {
                newContext[key] = dyDataParsed[key] || [];
            });
        }
    }
    setDYContext(newContext);
    return previousRecommendationContext;
}

function sendEngagement({ engagementUrl, decisionId, slotId }) {
    if (engagementUrl && decisionId) {
        var body = {};

        if (slotId) {
            body = {
                slotId: slotId
            }
        } else {
            body = {
                decisionId: decisionId
            }
        }

        fetch(engagementUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });
    }
}

module.exports = {
    setDyRecommendationContext: setDyRecommendationContext,
    sendEngagement: sendEngagement
};
